import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SeverityLevel } from '@hub4b/models/enums/severity-level';
import { HistoryPropertyCodes } from 'src/app/core/constantes/history-property-codes';
import { TableHeaderBaseDirective } from 'src/app/core/directives/table-header-base.directive';
import { AvmHistoryCellPipe } from 'src/app/core/pipes/avm-history-cell.pipe';
import { DateHelper } from 'src/app/helpers/date-helper';
import { ActionType } from 'src/app/models/enums/action-type';
import { CellType } from 'src/app/models/enums/cell-type';
import { DocumentFlux } from 'src/app/models/enums/document-flux';
import { DocumentType } from 'src/app/models/enums/document-type';
import { PropertyType } from 'src/app/models/enums/property-type';
import { ColumnDefinition } from 'src/app/models/server/column-definition';
import { History } from 'src/app/models/server/history';

@Component({
    selector: 'app-history-table-cell',
    templateUrl: './history-table-cell.component.html',
    styleUrls: ['./history-table-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule, MatTooltipModule, DatePipe, AvmHistoryCellPipe]
})
export class HistoryTableCellComponent extends TableHeaderBaseDirective {
    /**
     * Références des Enums utilisées dans le template.
     */
    public PropertyType = PropertyType;
    public DocumentType = DocumentType;
    public DocumentFlux = DocumentFlux;
    public ActionType = ActionType;
    public CellType = CellType;
    public SeverityLevel = SeverityLevel;

    /**
     * Références des constantes utilisées dans le template.
     */
    public FRENCH_DATETIME_FORMAT = DateHelper.FRENCH_DATETIME_FORMAT;
    public TYPE = HistoryPropertyCodes.TYPE;
    public SEVERITY = HistoryPropertyCodes.SEVERITY;

    /**
     * Type de donnée affiché dans la cellule.
     */
    public cellType: CellType;

    /**
     * Définition de la colonne à laquelle cette cellule appartient.
     */
    private _column: ColumnDefinition;

    /**
     * Spécifie la définition de la colonne à laquelle cette cellule appartient.
     */
    @Input()
    public set column(value: ColumnDefinition) {
        this._column = value;

        if (this.isStandardInputColumn(this._column)) {
            this.cellType = CellType.Standard;
        } else if (this.isListInputColumn(this._column)) {
            this.cellType = CellType.List;
        } else if (this.isEnumInputColumn(this._column)) {
            this.cellType = CellType.Enum;
        } else if (this.isDateInputColumn(this._column)) {
            this.cellType = CellType.Date;
        } else if (this.isDateAndTimeInputColumn(this._column)) {
            this.cellType = CellType.DateAndTime;
        }
    }

    /**
     * Obtient la définition de la colonne à laquelle cette cellule appartient.
     */
    public get column(): ColumnDefinition {
        return this._column;
    }

    /**
     * Instance de la ligne d'historique à afficher dans cette cellule.
     */
    private _data: History;

    /**
     * Spécifie l'instance de la ligne d'historique à afficher dans cette cellule.
     */
    @Input()
    public set data(value: History) {
        this._data = value;
    }

    /**
     * Obtient l'instance de la ligne d'historique à afficher dans cette cellule.
     */
    public get data(): History {
        return this._data;
    }

    /**
     * Constructeur.
     */
    constructor() {
        super();
    }
}
